module.exports = __webpack_public_path__ + "static/media/plane.f94375dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/plane.svg
// module id = 256
// module chunks = 0